module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order",
    style: (_vm.bannerFlag ? 'margin-top: 56px;' : '')
  }, [_c('div', {
    staticClass: "order-list w",
    staticStyle: {
      "min-height": "calc(100vh - 125px)"
    }
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('div', {
    staticClass: "search-box-left"
  }, [_c('div', {
    staticClass: "search-item"
  }, [_c('el-input', {
    attrs: {
      "size": "mini",
      "placeholder": "服务单号",
      "prefix-icon": "el-icon-search",
      "clearable": ""
    },
    on: {
      "clear": _vm.querySearch
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.querySearch.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryParams.servOrderNo),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "servOrderNo", $$v)
      },
      expression: "queryParams.servOrderNo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "search-item"
  }, [_c('el-cascader', {
    attrs: {
      "options": _vm.common.category,
      "props": _vm.optionProps,
      "clearable": "",
      "filterable": "",
      "show-all-levels": false,
      "size": "mini",
      "placeholder": "服务单类型"
    },
    on: {
      "change": _vm.changeServCataId
    },
    model: {
      value: (_vm.queryParams.servCataId),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "servCataId", $$v)
      },
      expression: "queryParams.servCataId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "search-item"
  }, [_c('el-select', {
    attrs: {
      "size": "mini",
      "placeholder": "数据类型"
    },
    model: {
      value: (_vm.queryParams.dataType),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "dataType", $$v)
      },
      expression: "queryParams.dataType"
    }
  }, _vm._l((_vm.common.dict.get('biz_scan_type')), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search-item"
  }, [_c('el-select', {
    attrs: {
      "size": "mini",
      "placeholder": "服务等级"
    },
    model: {
      value: (_vm.queryParams.desLevel),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "desLevel", $$v)
      },
      expression: "queryParams.desLevel"
    }
  }, _vm._l((_vm.common.dict.get('biz_des_level')), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search-item"
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#00a5d5",
      "inactive-color": "#909399",
      "active-value": "1",
      "inactive-value": "0",
      "active-text": "加急"
    },
    on: {
      "change": _vm.changeOrderRushFlag
    },
    model: {
      value: (_vm.queryParams.orderRushFlag),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "orderRushFlag", $$v)
      },
      expression: "queryParams.orderRushFlag"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "search-box-right"
  }, [_c('y-button', {
    attrs: {
      "text": "查询",
      "classStyle": "main-btn ml"
    },
    on: {
      "btnClick": _vm.querySearch
    }
  }), _vm._v(" "), _c('y-button', {
    attrs: {
      "text": "重置",
      "classStyle": "main-btn ml"
    },
    on: {
      "btnClick": _vm.resetSearch
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "height": "calc(100vh - 258px)"
    },
    attrs: {
      "element-loading-text": "加载中...",
      "element-loading-background": "rgba(0, 0, 0, 0)"
    }
  }, [_c('div', {
    staticClass: "table-wrap",
    staticStyle: {
      "height": "calc(100vh - 238px)"
    }
  }, [(_vm.orderList.length > 0) ? _c('el-table', {
    ref: "dataTable",
    staticStyle: {
      "width": "100%",
      "font-size": "13px"
    },
    attrs: {
      "data": _vm.orderList,
      "tooltip-effect": "dark",
      "size": "small",
      "height": "250",
      "stripe": true,
      "border": ""
    },
    nativeOn: {
      "mouseenter": function($event) {
        return _vm.mouseEnter.apply(null, arguments)
      },
      "mouseleave": function($event) {
        return _vm.mouseLeave.apply(null, arguments)
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "width": "60",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }], null, false, 4178052834)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "left",
      "label": "服务单号",
      "width": "210",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "code-wrap"
        }, [_vm._v("\n                  " + _vm._s(scope.row.servOrderNo) + "\n                  "), (scope.row.orderRushFlag === '1') ? _c('img', {
          attrs: {
            "src": "/static/images/rush.png"
          }
        }) : _vm._e()])]
      }
    }], null, false, 4170603303)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "服务单类型",
      "align": "center",
      "width": "170",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('serv-tag', {
          attrs: {
            "code": scope.row.servCataId
          }
        })]
      }
    }], null, false, 3852078241)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "服务等级",
      "align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!['1010410', '1010510', '1010698', '1010699', '1010700', '4010110'].includes(scope.row.servCataId)) ? _c('span', [_c('dict-tag', {
          attrs: {
            "dict": "biz_des_level",
            "value": scope.row.desLevel
          }
        })], 1) : _c('span', [_vm._v("-")])]
      }
    }], null, false, 2293376935)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderCount",
      "label": "数量",
      "width": "80",
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "金额",
      "width": "100",
      "align": "center",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                " + _vm._s(_vm.parseMoney(scope.row.orderAmount)) + "\n              ")]
      }
    }], null, false, 2522868571)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "数据类型",
      "align": "center",
      "width": "155"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('dict-tag', {
          attrs: {
            "dict": "biz_scan_type",
            "value": scope.row.dataType
          }
        })]
      }
    }], null, false, 1928601365)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "demName",
      "label": "公司名称",
      "width": "150",
      "header-align": "center",
      "align": "center",
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                 " + _vm._s(_vm.hideName(scope.row.demName)) + "\n              ")]
      }
    }], null, false, 1139647792)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('s-button', {
          class: !scope.row.canReceive ? 'disBtn' : '',
          attrs: {
            "text": "详情",
            "disabled": !scope.row.canReceive
          },
          on: {
            "btnClick": function($event) {
              return _vm.clickDetail(scope.row)
            }
          }
        }), _vm._v(" "), _c('s-button', {
          class: !scope.row.canReceive ? 'disBtn' : '',
          attrs: {
            "text": "接单",
            "disabled": !scope.row.canReceive
          },
          on: {
            "btnClick": function($event) {
              return _vm.clickConfirm(scope.row)
            }
          }
        })]
      }
    }], null, false, 3024693824)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.noData) ? _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n            暂无数据\n          ")]) : _vm._e(), _vm._v(" "), (_vm.orderList.length) ? _c('div', {
    staticClass: "pagination-wrap"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.pageNum,
      "page-size": _vm.queryParams.pageSize,
      "layout": "total,prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryParams, "pageNum", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryParams, "pageNum", $event)
      }
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    key: _vm.orderDetail.servOrderId,
    staticClass: "dialog-wrap",
    attrs: {
      "modal": false,
      "fullscreen": true,
      "modal-append-to-body": false,
      "visible": _vm.dialogVisible,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-wrap-header",
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('div', {
    staticClass: "dialog-header"
  }, [_vm._v("\n            " + _vm._s(_vm.orderDetail.servName)), _c('label', [_vm._v(" - ")]), _vm._v(_vm._s(_vm.orderDetail.servOrderNo)), _c('label', [_vm._v(" -\n            ")]), _vm._v(_vm._s(_vm.orderDetail.demPatient) + "\n            "), (_vm.orderDetail.orderRushFlag === '1') ? _c('img', {
    attrs: {
      "src": "/static/images/rush.png"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "dialog-button"
  }, [_c('y-button', {
    attrs: {
      "text": "接单",
      "classStyle": "main-btn"
    },
    on: {
      "btnClick": function($event) {
        return _vm.clickConfirm(_vm.orderDetail)
      }
    }
  }), _vm._v(" "), _c('y-button', {
    attrs: {
      "text": "返回",
      "classStyle": "main-btn"
    },
    on: {
      "btnClick": _vm.clickCloseDetail
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-wrap-content"
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.handleTabClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "info"
    }
  }, [_c('span', {
    staticClass: "tabs-pane-title",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-data-analysis"
  }), _vm._v(" "), _c('span', [_vm._v("服务单详情")])]), _vm._v(" "), _c('div', {
    staticClass: "tabs-pane-content"
  }, [(!['4010110', '3010130', '4010120'].includes(_vm.orderDetail.servCataId)) ? _c('detail-order', {
    attrs: {
      "orderDetail": _vm.orderDetail
    }
  }) : _vm._e(), _vm._v(" "), (['3010130'].includes(_vm.orderDetail.servCataId)) ? _c('orth-order', {
    attrs: {
      "orderDetail": _vm.orderDetail
    }
  }) : _vm._e(), _vm._v(" "), (['4010110', '4010120'].includes(_vm.orderDetail.servCataId)) ? _c('active-order', {
    attrs: {
      "orderDetail": _vm.orderDetail
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "data"
    }
  }, [_c('span', {
    staticClass: "tabs-pane-title",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_c('i', {
    staticClass: "el-icon-film"
  }), _vm._v(" "), _c('span', [_vm._v("数据详情")])]), _vm._v(" "), _c('div', {
    staticClass: "tabs-pane-content"
  }, [_c('detail-down', {
    attrs: {
      "orderDetail": _vm.orderDetail,
      "isDown": false
    }
  })], 1)])], 1)], 1)])], 1), _vm._v(" "), _c('Customer', {
    staticClass: "customerSer"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-135d067d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/orderMall.vue
// module id = 607
// module chunks = 0